export const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line' },
  { name: 'Hoodies / Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-vip-line' },
  { name: 'Pants / Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-pantone-line' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-base-station-line' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line' },
  { name: 'Underwear / Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-shirt-line' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-basketball-line' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-glasses-line' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-handbag-line' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-anchor-line' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-drop-line' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line' },
];

export const featuredCategories = [
  {
    name: 'Shoes',
    description: 'Curated sneaker and footwear spreadsheet — discover trending kicks, limited releases, and classic silhouettes all in one organized database.',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    imageSeq: 'feat-shoes-01',
  },
  {
    name: 'Hoodies & Sweaters',
    description: 'Browse the complete hoodie and sweater collection spreadsheet. From streetwear staples to premium knitwear, find every style organized and ready to explore.',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    imageSeq: 'feat-hoodies-01',
  },
  {
    name: 'Jackets & Outerwear',
    description: 'Your jacket discovery spreadsheet — bomber, denim, puffer, varsity. Comprehensive outerwear database for every season and every style preference.',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-vip-line',
    imageSeq: 'feat-jackets-01',
  },
  {
    name: 'Bags & Backpacks',
    description: 'Explore the bags spreadsheet featuring crossbody, tote, duffel, and backpack resources. Organized product data for functional and fashion-forward bag shopping.',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-handbag-line',
    imageSeq: 'feat-bags-01',
  },
  {
    name: 'Accessories',
    description: 'The accessories spreadsheet hub — watches, eyewear, jewelry, hats, and more. Complete your look with organized accessory discovery resources.',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-glasses-line',
    imageSeq: 'feat-accessories-01',
  },
  {
    name: 'Jerseys & Sportswear',
    description: 'Dive into sportswear and jersey spreadsheets. Basketball, football, soccer, and baseball jerseys all cataloged in one searchable resource.',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-basketball-line',
    imageSeq: 'feat-jersey-01',
  },
];

export const testimonials = [
  {
    name: 'Marcus Thompson',
    role: 'Sneaker Collector',
    content: 'The Hipobuy Spreadsheet completely changed how I discover new releases. Instead of scrolling through dozens of sites, I have everything organized in one place. The category breakdown is incredibly intuitive.',
    avatarSeq: 'avatar-marcus',
  },
  {
    name: 'Elena Rodriguez',
    role: 'Fashion Blogger',
    content: 'As someone who writes about streetwear daily, having access to organized spreadsheet databases saves me hours of research. The Hipobuy Spreadsheet resource has become an essential part of my workflow.',
    avatarSeq: 'avatar-elena',
  },
  {
    name: 'James Chen',
    role: 'Online Shopping Enthusiast',
    content: 'I used to waste so much time jumping between different platforms trying to compare products. The Hipobuy Spreadsheet hub puts everything at my fingertips — it is genuinely the best shopping research tool I have found.',
    avatarSeq: 'avatar-james',
  },
];